function CheckboxEnableElement() {
  $('input[type=checkbox][data-enable-element]').each((i, checkbox) => {
    const $targetChange = $(checkbox.dataset.enableElement);

    // Inicia habilitado/desabilitado de acordo com o valor inicial do checkbox
    $targetChange.prop('disabled', !checkbox.checked);

    // Habilita/desabilita o elemento de acordo com a alteração do estado do checkbox
    checkbox.addEventListener('change', event => {
      $targetChange.prop('disabled', () => !checkbox.checked);
    });
  });
}

exports.init = CheckboxEnableElement;
